export const ADMIN_SECTIONS = [
    "overview",
    "aispend",
    "funnel",
    "simulator",
    "seo",
    "accessibility",
    "benchmark",
    "users",
    "monetization",
    "billing",
    "settings",
];
export function parseAdminSectionHash(hash, fallback = "overview") {
    const raw = hash.replace(/^#/, "").trim().toLowerCase();
    return ADMIN_SECTIONS.includes(raw) ? raw : fallback;
}
export function adminSectionHash(section) {
    return `#${section}`;
}
//# sourceMappingURL=admin-section-hash.js.map